/* unplugin-vue-components disabled */import { render } from "./PrivacyPolicyIos.vue?vue&type=template&id=5a9706cf&scoped=true"
import script from "./PrivacyPolicyIos.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyIos.vue?vue&type=script&lang=js"

import "./PrivacyPolicyIos.vue?vue&type=style&index=0&id=5a9706cf&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9706cf"]])

export default __exports__